/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  DeleteSmsReceptionDtoTx,
  GetSmsReceptionDtoRx,
  SmsReceptionControllerGetSmsReceptionsParams,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class SmsReceptionApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags SMS Reception API
   * @name SmsReceptionControllerGetSmsReceptions
   * @summary SMS 수신 조회
   * @request GET:/api/sms-reception
   * @secure
   */
  smsReceptionControllerGetSmsReceptions = (
    query: SmsReceptionControllerGetSmsReceptionsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetSmsReceptionDtoRx, any>({
      path: `/api/sms-reception`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SMS Reception API
   * @name SmsReceptionControllerDeleteSmsReception
   * @summary SMS 수신 삭제
   * @request DELETE:/api/sms-reception
   * @secure
   */
  smsReceptionControllerDeleteSmsReception = (data: DeleteSmsReceptionDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/sms-reception`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
